export default "__VITE_PUBLIC_ASSET__406c8515__"